var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialTg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#E9E9E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6646 13.7168L10.9346 20.5538C9.72461 21.0398 9.73161 21.7148 10.7126 22.0158L15.2646 23.4358L25.7966 16.7908C26.2946 16.4878 26.7496 16.6508 26.3756 16.9828L17.8426 24.6838H17.8406L17.8426 24.6848L17.5286 29.3768C17.9886 29.3768 18.1916 29.1658 18.4496 28.9168L20.6606 26.7668L25.2596 30.1638C26.1076 30.6308 26.7166 30.3908 26.9276 29.3788L29.9466 15.1508C30.2556 13.9118 29.4736 13.3508 28.6646 13.7168Z",
    fill: "#054FD6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTg);
export default __webpack_public_path__ + "static/media/social-tg.508a80e3cf26d04f120592684e2f2094.svg";
export { ForwardRef as ReactComponent };